module.exports = __webpack_public_path__ + "img/uni-eth-usdt.0a41c5b5.svg";